import { render, staticRenderFns } from "./create-location.vue?vue&type=template&id=064a952c&"
import script from "./create-location.vue?vue&type=script&lang=js&"
export * from "./create-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports